import React from "react";

const DownloadOutReachXLSX = () => {
  const handleDownload = () => {
    const csvUrl = "/outreach_xl.xlsx";
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "sample_outreach-xlxs.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      className='bg-red-600 px-3 py-1 rounded text-white'
      color=''
      onClick={handleDownload}
    >
      Download XLSX
    </button>
  );
};

export default DownloadOutReachXLSX;
